import React, { useState, useEffect } from "react";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ApiAmusementService from "../../../core/api/api.amusementService";
import "../../pages/_Components/ReactBeautifulDnd.css";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import SwalMessage from "../_Components/SwalMessage";
import { Button, Modal, Col, Row } from "react-bootstrap";
import ApiAmusementComplex from "../../../core/api/api.amusementComplex";
import SelectComponent from "../_Components/ReactSelectComponent";
import ApiRegion from "../../../core/api/api.region";

const ChangeOrderAmusementService = ({ showModalAmusementsOrder, setShowModalAmusementsOrder, selectedComplexId }) => {
  const [items, setItems] = useState([]);
  const [listAmusementComplex, setListAmusementComplex] = useState([]);
  const [allAmusementCityList, setAllAmusementCityList] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedAmusementComplex, setSelectedAmusementComplex] = useState(null);

  const getAmusemntServices = async (selectedAmusementComplex, selectedCity) => {
    try {
      const response = await ApiAmusementService.getAllServicesByComplexId({
        complexId: selectedAmusementComplex?.value,
        regionId: selectedCity?.value,
      });
      setItems(response);
    } catch (error) {
    }
  };

  const handleComplexChange = (selectedOption) => {
    setSelectedAmusementComplex(selectedOption);
    getAmusemntServices(selectedOption, selectedCity);
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
    getAmusemntServices(selectedAmusementComplex, selectedOption);
  };


  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const updatedItems = Array.from(items);
    const [reorderedItem] = updatedItems.splice(result.source.index, 1);
    updatedItems.splice(result.destination.index, 0, reorderedItem);

    setItems(updatedItems);
  };

  const handleClose = () => {
    setShowModalAmusementsOrder(false);
  };

  const sendSortedItems = async () => {
    if (!selectedCity) {
      SwalMessage({ title: "لطفا شهر را انتخاب کنید", iSsuccess: false });
      return;
    }
    try {
      const dataToSend = {
        services: items.map((item) => ({ id: item.amusementServiceId, name: item.amusementService.name })),
        complexId: selectedAmusementComplex?.value,
        regionId: selectedCity?.value,
      };
      const response = await ApiAmusementService.changeOrderAmusementServiceInComplex(dataToSend);
      SwalMessage({ title: response.message, iSsuccess: true });
    } catch (error) {
    }
  };

  useEffect(() => {
    (async () => {
      try {
        if (selectedComplexId) {
          const [servicesResponse, complexsResponse, citiesResponse] = await Promise.all([
            ApiAmusementService.getAllServicesByComplexId({ complexId: selectedComplexId }),
            ApiAmusementComplex.getAmusementComplexes(),
            ApiRegion.getAllCity(),
          ]);
          setItems(servicesResponse);
          setListAmusementComplex(complexsResponse);
          setAllAmusementCityList(citiesResponse);

          const initialComplex = complexsResponse.find((service) => service.id === selectedComplexId);
          if (initialComplex) {
            setSelectedAmusementComplex({
              value: initialComplex.id,
              label: initialComplex.name,
            });
          }
        }
      } catch (error) {
      }
    })();
  }, [selectedComplexId]);

  return (
    <div>
      <div className="card-body pt-3 pb-0">
        <Modal centered size="md" show={showModalAmusementsOrder} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>ترتیب قرارگیری سرویس‌ها در این مجتمع</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="gx-1 mb-2">
              <Col sm="4" className="pr-sm-0">
                <SelectComponent
                  className=" mt-2"
                  placeholder="شهر"
                  options={allAmusementCityList.map((item) => ({
                    value: item.id,
                    label: `${item.id}-${item.name}`,
                  }))}
                  onChange={handleCityChange}
                  value={selectedCity}
                />
              </Col>
              <Col sm="8" className="">
                <SelectComponent
                  className=" mt-2"
                  placeholder="مجتمع تفریح"
                  options={listAmusementComplex.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                  onChange={handleComplexChange}
                  value={selectedAmusementComplex}
                />
              </Col>
            </Row>

            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <ul className="sortable-list" {...provided.droppableProps} ref={provided.innerRef}>
                    {items.map((item, index) => (
                      <Draggable
                        key={item.amusementServiceId}
                        draggableId={item.amusementServiceId.toString()}
                        index={index}
                      >
                        {(provided) => (
                          <li
                            className="sortable-item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                          >
                            <span>{item.amusementService.name}</span>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" disabled={!selectedCity} onClick={sendSortedItems}>
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default ChangeOrderAmusementService;
